import React from 'react';

// components
import { General } from 'icons/untitledui';

// hooks
import { ECoachSession } from 'shared/hooks/api/ecoach';

// styles
import * as AllChats from 'eCoach/_styles/AllChats.style';
import colours from 'theme/atoms/colours';

interface DeleteButtonProps {
  chat: ECoachSession;
  openDeleteModal: (e: React.MouseEvent, chat: ECoachSession) => void;
}

export default function DeleteButton({
  chat,
  openDeleteModal,
}: DeleteButtonProps): JSX.Element {
  return (
    <AllChats.DeleteIcon>
      <General.Trash01
        onClick={(e: React.MouseEvent) => openDeleteModal(e, chat)}
        stroke={colours.neutral[600]}
        size={16}
      />
    </AllChats.DeleteIcon>
  );
}
